(() => {
  const productPath = '/products/set-de-zuecos-y-calcetines-para-enfermeras';
  if (window.location.pathname !== productPath) return;

  const variantId = new URL(window.location.href).searchParams.get('variant');
  const choices = {
  "65813013102941": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "36"
  },
  "65813013135709": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "36"
  },
  "65813013168477": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "36"
  },
  "65813013201245": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "36.5"
  },
  "65813013234013": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "36.5"
  },
  "65813013266781": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "36.5"
  },
  "65813013299549": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "37"
  },
  "65813013332317": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "37"
  },
  "65813013365085": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "37"
  },
  "65813013397853": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "38"
  },
  "65813013430621": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "38"
  },
  "65813013463389": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "38"
  },
  "65813013496157": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "38.5"
  },
  "65813013528925": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "38.5"
  },
  "65813013561693": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "38.5"
  },
  "65813013594461": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "39"
  },
  "65813013627229": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "39"
  },
  "65813013659997": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "39"
  },
  "65813013692765": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "40"
  },
  "65813013725533": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "40"
  },
  "65813013758301": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "40"
  },
  "65813013791069": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "40.5"
  },
  "65813013823837": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "40.5"
  },
  "65813013856605": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "40.5"
  },
  "65813013889373": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "41"
  },
  "65813013922141": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "41"
  },
  "65813013954909": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "41"
  },
  "65813013987677": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "42"
  },
  "65813014020445": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "42"
  },
  "65813014053213": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Aqua",
    "size": "42"
  },
  "65813014085981": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "36"
  },
  "65813014118749": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "36"
  },
  "65813014151517": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "36"
  },
  "65813014184285": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "36.5"
  },
  "65813014217053": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "36.5"
  },
  "65813014249821": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "36.5"
  },
  "65813014282589": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "37"
  },
  "65813014315357": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "37"
  },
  "65813014348125": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "37"
  },
  "65813014380893": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "38"
  },
  "65813014413661": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "38"
  },
  "65813014446429": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "38"
  },
  "65813014479197": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "38.5"
  },
  "65813014511965": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "38.5"
  },
  "65813014544733": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "38.5"
  },
  "65813014577501": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "39"
  },
  "65813014610269": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "39"
  },
  "65813014643037": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "39"
  },
  "65813014675805": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "40"
  },
  "65813014708573": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "40"
  },
  "65813014741341": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "40"
  },
  "65813014774109": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "40.5"
  },
  "65813014806877": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "40.5"
  },
  "65813014839645": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "40.5"
  },
  "65813014872413": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "41"
  },
  "65813014905181": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "41"
  },
  "65813014937949": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "41"
  },
  "65813014970717": {
    "sock": "Calcetines Altos para Enfermeras (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "42"
  },
  "65813015003485": {
    "sock": "Calcetines Altos para Enfermeras con Patrones (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "42"
  },
  "65813015036253": {
    "sock": "Calcetines Altos para Enfermeras con Dibujos (Set de 3)",
    "clog": "Zuecos para Enfermeras Blanco Morado",
    "size": "42"
  }
};
  const selection = choices[variantId];
  if (!selection || selection.size === '42') return;

  const deadline = Date.now() + 30000;
  let stage = 'initialization';
  const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const visible = (element) => element && element.getClientRects().length > 0 &&
    window.getComputedStyle(element).display !== 'none';
  const currentMoon = () => document.querySelector('moonbundle-component');
  const currentSlot = (index) => currentMoon()?.querySelectorAll('.moonbundle-multi-product-stacked-row')[index];
  const selected = (index, title, size) => {
    const slot = currentSlot(index);
    return slot?.textContent.includes(title) &&
      (!size || [...slot.querySelectorAll('select')].some((element) => element.value === size));
  };

  async function waitFor(find) {
    while (Date.now() < deadline) {
      const result = find();
      if (result) return result;
      await pause(75);
    }
    throw new Error(`Moon no ha completado la selección del enlace de variante (${stage})`);
  }

  async function chooseProduct(index, title, size) {
    if (selected(index, title, size)) return;
    stage = `open picker: ${title}`;
    const picker = await waitFor(() =>
      selected(index, title, size) ||
      [...(currentSlot(index)?.querySelectorAll('.moonbundle-ai-slot-picker-cta, .moonbundle-ai-slot-change-btn') || [])].find(visible));
    if (picker === true) return;
    picker.click();

    stage = `find popup: ${title}`;
    const popup = await waitFor(() =>
      [...document.querySelectorAll('.moonbundle-dynamic-popup-overlay')].find(visible));
    stage = `find product: ${title}`;
    const card = await waitFor(() =>
      [...popup.querySelectorAll('.moonbundle-dynamic-popup-product-card')].find((element) =>
        element.querySelector('.moonbundle-dynamic-popup-product-title')?.textContent.trim() === title));
    const selectProduct = card.querySelector('.moonbundle-dynamic-popup-cta');
    if (!selectProduct) throw new Error('Moon no muestra el selector del producto anunciado');
    selectProduct.click();

    if (size) {
      stage = `find size: ${title} / ${size}`;
      const variant = await waitFor(() =>
        [...popup.querySelectorAll('.moonbundle-dynamic-popup-variant-card')].find((element) =>
          element.textContent.trim() === size));
      variant.click();
    }
    stage = `confirm selection: ${title}`;
    await waitFor(() => selected(index, title, size));
  }

  (async () => {
    stage = 'find Moon component';
    await waitFor(currentMoon);
    stage = 'find two Moon slots';
    await waitFor(() => currentMoon()?.querySelectorAll('.moonbundle-multi-product-stacked-row').length === 2);
    await chooseProduct(0, selection.sock);
    await chooseProduct(1, selection.clog, selection.size);
    currentMoon().dataset.nilFeedVariantSelected = variantId;
    document.documentElement.dataset.nilFeedVariantSelected = variantId;
  })().catch((error) => {
    console.warn('[NIL Moon feed variant]', error.message);
  });
})();

